export const blackPixel =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAF0lEQVQoU2NkYGBg+M+ABBgAAAD//wMAA38CBP4AAAAASUVORK5CYII=';
